import { render, staticRenderFns } from "./TeacherSchedulesRegularCard.vue?vue&type=template&id=bc0f2074&scoped=true&"
import script from "./TeacherSchedulesRegularCard.vue?vue&type=script&lang=js&"
export * from "./TeacherSchedulesRegularCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSchedulesRegularCard.vue?vue&type=style&index=0&id=bc0f2074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0f2074",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})
